import React, {ReactElement} from 'react';
import {IElementModal} from '../../../incase-domain/elements/modal';
import './modal.css';

interface IElementModalComponentProps {
    element: IElementModal;
}

function ElementModalComponent(props: IElementModalComponentProps): ReactElement {
    const {element} = props;

    return (
        <div id={element.id} className="modal">
            <div className="modal-header">
                <h2 className="modal-title" style={{fontFamily: element.fontFamily?.name}}>
                    {element.title || 'New Modal'}
                </h2>
            </div>
        </div>
    );
}

export default ElementModalComponent;
